import { prop, arrayToObject, getImagePath } from '../../utilities';
import { IconType } from './General/SvgIcon';

function getZlataPriadkaSymbolData(symbolNumber: string) {
  let type;
  let tooltip;

  switch (symbolNumber) {
    case '1':
      type = IconType.symbol_1;
      tooltip = 'Pranie len v rukách';
      break;
    case '2':
      type = IconType.symbol_2;
      tooltip = 'Pranie v práčke max. 30 stupňov';
      break;
    case '3':
      type = IconType.symbol_3;
      tooltip = 'Pranie v práčke max. 40 stupňov';
      break;
    case '4':
      type = IconType.symbol_4;
      tooltip = 'Pranie v práčke max. 60 stupňov';
      break;
    case '5':
      type = IconType.symbol_5;
      tooltip = 'Pranie v práčke max. 95 stupňov';
      break;
    case '6':
      type = IconType.symbol_6;
      tooltip = 'Neprať';
      break;
    case '7':
      type = IconType.symbol_7;
      tooltip = 'Žehlenie max. na teplote 1';
      break;
    case '8':
      type = IconType.symbol_8;
      tooltip = 'Žehlenie max. na teplote 2';
      break;
    case '9':
      type = IconType.symbol_9;
      tooltip = 'Žehlenie max. na teplote 3';
      break;
    case '10':
      type = IconType.symbol_10;
      tooltip = 'Nežehliť';
      break;
    case '11':
      type = IconType.symbol_11;
      tooltip = 'Môže sa bieliť';
      break;
    case '12':
      type = IconType.symbol_12;
      tooltip = 'Nesmie sa bieliť';
      break;
    case '13':
      type = IconType.symbol_13;
      tooltip = 'Môže sa sušiť v sušičke pri nízkej teplote';
      break;
    case '14':
      type = IconType.symbol_14;
      tooltip = 'Môže sa sušiť v sušičke pri strednej teplote';
      break;
    case '15':
      type = IconType.symbol_15;
      tooltip = 'Nesušiť v sušičke';
      break;
    case '16':
      type = IconType.symbol_16;
      tooltip = 'Nečistiť chemicky';
      break;
    default:
      type = IconType.symbol_17;
      tooltip = 'Môže sa čistiť chemicky';
      break;
  }
  return { type, tooltip };
}

function getFooterContactRowData(contactInfo: any) {
  return [
    {
      type: 'email',
      value: contactInfo.email,
      smallText: '',
      url: `mailto:${contactInfo.email}`,
    },
    {
      type: 'phone',
      value: contactInfo.phone,
      // TODO change opening hours
      smallText: 'Po-Pia 8:00-15:00',
      url: `tel:${contactInfo.phone}`,
    },
    {
      type: 'facebook',
      value: 'Facebook',
      smallText: '',
      url: contactInfo.facebook || '',
    },
  ];
}

function getZlataPriadkaProductDefaultInfo(product, goodName = 'main_good') {
  const unit = prop(product, `${goodName}.units`) || 'ks';

  const customOrderNrs = prop(product, `${goodName}.custom_order_nr`, ['']);
  const orderNr = customOrderNrs
    ? customOrderNrs[customOrderNrs.length - 1]
    : '';

  const b2bDiscount = prop(product, `${goodName}.b2b_discount`, null);
  const assembling = prop(product, 'assembling');
  const storesInfo = prop(product, `${goodName}.stores_info`, null);
  const onStockCount = prop(product, `${goodName}.on_stock_count`, 0);
  const customerDiscount = prop(product, `${goodName}.customer_discount`);
  const price = prop(product, `${goodName}.final_price`);
  const oldPrice = prop(product, `${goodName}.oldprice`);
  const priceWithoutVat = prop(product, `${goodName}.final_price_without_vat`);
  const unpackingCost = prop(product, `${goodName}.sum_unpacking_cost`);
  const unpackingCostWithoutVat = prop(
    product,
    `${goodName}.sum_unpacking_cost_without_vat`,
  );
  const showB2C = prop(product, 'status_b2c') ? false : true;
  const showB2B = prop(product, 'status_b2b') ? false : true;
  const statusB2C = prop(product, 'status_b2c', 0);
  const statusB2B = prop(product, 'status_b2b', 0);
  const freeDelivery = prop(product, 'free_delivery', false);
  const specialDiscountPcn = prop(product, `${goodName}.special_discount_pcn`);
  const specialDiscount = prop(product, `${goodName}.special_discount`);
  const specialDiscountWithoutVat = prop(
    product,
    `${goodName}.special_discount_without_vat`,
  );
  const customerDiscountPcn = prop(
    product,
    `${goodName}.customer_discount_pcn`,
  );
  const productPackages = prop(product, 'productPackages', []);
  const customerPrices = prop(product, `${goodName}.customer_prices`);
  const photogallery = prop(product, 'photogallery');
  const picture =
    prop(product, 'picture') || prop(product, 'product_detail.picture');

  return {
    photogallery,
    freeDelivery,
    unit,
    onStock: onStockCount,
    price: price ? price.toFixed(2) : 0,
    priceWithoutVat: priceWithoutVat ? priceWithoutVat.toFixed(2) : 0,
    oldPrice: oldPrice ? oldPrice.toFixed(2) : 0,
    assembling,
    orderNr,
    priceForPiece: priceWithoutVat ? priceWithoutVat.toFixed(2) : 0,
    customerDiscount: customerDiscount ? customerDiscount.toFixed(2) : 0,
    b2bDiscount,
    unpackingCost,
    unpackingCostWithoutVat,
    storesInfo,
    showB2C,
    showB2B,
    statusB2C,
    statusB2B,
    customerDiscountPcn,
    specialDiscountPcn,
    specialDiscount,
    specialDiscountWithoutVat,
    customerPrices,
    productPackages,
    picture,
    image: picture
      ? getImagePath(
          process.env.REACT_APP_API_BASE_URL as string,
          picture.includes('product/') ? picture : `product/${picture}`,
          {
            width: 320,
            height: 320,
          },
        )
      : '/images/zlatapriadka/placeholder.svg',
  };
}

const getElasticCategoryZlataPriadkaProductInfo = (product, isB2B) => {
  const unit = prop(product, 'helios_units')
    ? prop(product, 'helios_units')
    : 'ks';
  const isMks = unit === 'Mks';

  const storesInfo = prop(product, `stores_info`, null);
  const storesInfoObj = storesInfo
    ? arrayToObject(storesInfo, 'store_id')
    : null;
  const correctZemplinCount = storesInfoObj
    ? prop(storesInfoObj, 'internal.quantity')
    : null;
  const onStockCount = correctZemplinCount
    ? correctZemplinCount
    : prop(product, `main_good_stock_count`, 0);
  const correctCount = isMks ? onStockCount / 1000 : onStockCount;

  const price = prop(product, `product_detail.main_good.final_price`);
  const priceWithoutVat = prop(
    product,
    `product_detail.main_good.final_price_without_vat`,
  );

  const correctPrice = price
    ? isMks
      ? (1000 * price).toFixed(6)
      : price.toFixed(6)
    : '';

  const correctPriceWithoutVat = priceWithoutVat
    ? isMks
      ? (1000 * priceWithoutVat).toFixed(6)
      : priceWithoutVat.toFixed(6)
    : '';

  const productPackages = prop(product, `product_packages`);
  const goods = prop(product, `product_detail.goods`, []);
  const minQuantity = goods ? prop(goods[0], `order_quantity_min`, null) : null;
  const correctPackageNumber = minQuantity
    ? isMks
      ? minQuantity / 1000
      : minQuantity
    : getCorrectPackageNumber(productPackages, isMks);

  const unpackingCost = prop(
    product,
    `product_detail.main_good.sum_unpacking_cost`,
  );
  const unpackingCostWithoutVat = prop(
    product,
    `product_detail.main_good.sum_unpacking_cost_without_vat`,
  );

  const customOrderNrs = prop(
    product,
    'product_detail.main_good.custom_order_nr',
  );
  const customOrderNr =
    customOrderNrs && customOrderNrs[0] ? customOrderNrs : null;

  const statusB2C = prop(product, 'status_b2c', 0);
  const statusB2B = prop(product, 'status_b2b', 0);
  const showB2C = prop(product, 'status_b2c') ? false : true;
  const showB2B = prop(product, 'status_b2b') ? false : true;
  const statusShowPrice = isB2B ? statusB2B !== 3 : statusB2C !== 3;
  const statusShowAddToCart = isB2B ? statusB2B === 0 : statusB2C === 0;

  const specialDiscountPcn = prop(
    product,
    `product_detail.main_good.special_discount_pcn`,
  );
  const specialDiscount = prop(
    product,
    `product_detail.main_good.special_discount`,
  );
  const specialDiscountWithoutVat = prop(
    product,
    `product_detail.main_good.special_discount_without_vat`,
  );
  const currency = prop(product, 'product_detail.main_good.currency.name', '')
    ? '€'
    : '€';
  const correctShownSpecialDiscount =
    specialDiscountPcn && specialDiscountPcn !== 0
      ? specialDiscountPcn
      : isB2B
      ? specialDiscountWithoutVat
      : specialDiscount;
  const correctShownSpecialDiscountText =
    correctShownSpecialDiscount && correctShownSpecialDiscount !== 0
      ? specialDiscountPcn && specialDiscountPcn
        ? `-${correctShownSpecialDiscount}%`
        : `${(isMks
            ? correctShownSpecialDiscount * 1000
            : correctShownSpecialDiscount
          ).toFixed(2)}${currency}`
      : '';
  const freeDelivery = prop(product, `product_detail.free_delivery`);
  const priceForUnpacking = prop(
    product,
    'product_detail.main_good.price_for_unpacking',
  );
  const customerPrices = prop(
    product,
    `product_detail.main_good.customer_prices`,
  );

  return {
    priceForUnpacking,
    freeDelivery,
    onStock: correctCount,
    storesInfo,
    price: correctPrice,
    priceWithoutVat: correctPriceWithoutVat,
    unit,
    productPackages: correctPackageNumber,
    unpackingCost,
    unpackingCostWithoutVat,
    customOrderNr,
    showB2C,
    showB2B,
    statusShowPrice,
    statusShowAddToCart,
    specialDiscount: correctShownSpecialDiscountText,
    customerPrices,
    correctShownSpecialDiscount,
  };
};

function getZlataPriadkaCartProductInfo(product) {
  const unit = prop(product, 'good.units') || 'ks';
  const isMks = false;

  const productPackages = prop(product, 'product.productPackages', []);
  const minQuantity = prop(product, `good.order_quantity_min`);
  const correctPackageNumber = minQuantity
    ? isMks
      ? minQuantity / 1000
      : minQuantity
    : getCorrectPackageNumber(productPackages, isMks);

  const count = prop(product, 'count');
  const correctCount = isMks ? count / 1000 : count;

  const unitPrice = prop(product, `good.unitprice`);

  const price = prop(product, `good.final_price`);
  const priceWithoutVat = prop(product, `good.final_price_without_vat`);
  const sumPrice = prop(product, `sum_price`);
  const sumPriceWithoutVat = prop(product, `sum_price_without_vat`);
  const finalPricePerUnitWithVat = prop(
    product,
    `final_price_per_unit_with_vat`,
  );
  const finalPricePerUnitWithoutVat = prop(
    product,
    `final_price_per_unit_without_vat`,
  );

  const correctPrice = price
    ? isMks
      ? (1000 * price).toFixed(6)
      : price.toFixed(6)
    : '';
  const correctPriceWithoutVat = priceWithoutVat
    ? isMks
      ? (1000 * priceWithoutVat).toFixed(6)
      : priceWithoutVat.toFixed(6)
    : '';
  const correctFinalPricePerUnitWithVat = finalPricePerUnitWithVat
    ? finalPricePerUnitWithVat.toFixed(6)
    : '';
  const correctFinalPricePerUnitWithoutVat = finalPricePerUnitWithoutVat
    ? finalPricePerUnitWithoutVat.toFixed(6)
    : '';

  const storesInfo = prop(product, `good.stores_info`, null);
  const storesInfoObj = storesInfo
    ? arrayToObject(storesInfo, 'store_id')
    : null;
  const correctZemplinCount = storesInfoObj
    ? prop(storesInfoObj, 'internal.quantity')
    : null;
  const onStockCount = correctZemplinCount
    ? correctZemplinCount
    : prop(product, `good.on_stock_count`, 0);
  const b2BDiscount = prop(product, `good.b2b_discount`);
  const priceForUnpacking = prop(product, `unpacking_cost`);

  return {
    priceForUnpacking,
    count: correctCount,
    unit,
    productPackages: correctPackageNumber,
    price: correctPrice,
    priceWithoutVat: correctPriceWithoutVat,
    priceForPiece: price,
    priceForPieceWithoutVat: priceWithoutVat,
    sumPrice: sumPrice ? sumPrice.toFixed(2) : '',
    sumPriceWithoutVat: sumPriceWithoutVat ? sumPriceWithoutVat.toFixed(2) : '',
    onStock: onStockCount,
    storesInfo,
    finalPricePerUnitWithVat: correctFinalPricePerUnitWithVat,
    finalPricePerUnitWithoutVat: correctFinalPricePerUnitWithoutVat,
    b2BDiscount,
    unitPrice,
  };
}

function getZlataPriadkaCartSummaryInfo(cart) {
  const vatGroups = prop(cart, 'vat_groups', null);
  if (!vatGroups) {
    return {
      vatGroups: null,
    };
  }
  const vatGroup0Total = prop(vatGroups['0'], 'price_without_vat')
    ? prop(vatGroups['0'], 'price_without_vat').toFixed(2)
    : null;
  const vatGroup0TotalWithDph = prop(vatGroups['0'], 'price')
    ? prop(vatGroups['0'], 'price').toFixed(2)
    : null;
  const vatGroup20Total = prop(vatGroups['20'], 'price_without_vat')
    ? prop(vatGroups['20'], 'price_without_vat').toFixed(2)
    : null;
  const vatGroup20TotalWithDph = prop(vatGroups['20'], 'price')
    ? prop(vatGroups['20'], 'price').toFixed(2)
    : null;
  const vatGroup20TotalDph = vatGroup20TotalWithDph - vatGroup20Total;

  return {
    vatGroup0Total,
    vatGroup0TotalWithDph,
    vatGroup20Total,
    vatGroup20TotalWithDph,
    vatGroup20TotalDph: vatGroup20TotalDph
      ? vatGroup20TotalDph.toFixed(2)
      : null,
  };
}

function getZlataPriadkaTrueCount(isMks: boolean, count: number) {
  return isMks ? Math.round(count * 1000) : count;
}

function getZlataPriadkaTrueCountFromNormalCount(
  isMks: boolean,
  count: number,
) {
  return isMks ? count / 1000 : count;
}

function getCorrectPackageNumber(packages, isMks: boolean) {
  if (!packages || packages.length === 0) {
    return 0;
  }

  const packageNumbers = packages.map(p => p.type);
  const min = Math.min(...packageNumbers);

  return isMks ? min / 1000 : min;
}

function isOrderingLessThanMinimum(product) {
  const {
    count,
    productPackages,
    priceForUnpacking,
  } = getZlataPriadkaCartProductInfo(product);
  if (
    count < productPackages &&
    productPackages >= 0.026 &&
    priceForUnpacking &&
    priceForUnpacking * +count < 4
  ) {
    return true;
  }

  return false;
}

function getZlataPriadkaRequestDetailItemInfo(item) {
  const unit = prop(item, 'good_details_json.units');
  const heliosUnit = prop(item, 'good_details_json.heliosUnits');
  const correctUnit = heliosUnit || unit;
  const isMks = correctUnit === 'Mks';
  const quantity = prop(item, 'quantity');

  const correctCount = isMks ? quantity / 1000 : quantity;

  return {
    count: correctCount,
    unit: correctUnit,
  };
}

function shouldShowPriceIfNotOnStock(categoryIds: string[]) {
  return !categoryIds.includes('SPOJ_MATERIAL');
}

function isCategory(categoryIds: string[], wantedCategory: string) {
  return categoryIds.includes(wantedCategory);
}

function findCategoryIdFromArray(categoryIds: string[]) {
  if (categoryIds.includes('CENTRUM_VYKUROV')) {
    return 'CENTRUM_VYKUROV';
  }

  if (categoryIds.includes('PRE_DREVAROV')) {
    return 'PRE_DREVAROV';
  }

  if (categoryIds.includes('OSTATNE')) {
    return 'OSTATNE';
  }

  return 'SPOJ_MATERIAL';
}

const getDownloadFileInfo = download => {
  const id = prop(download, 'document_id', '');
  const path = prop(download, 'document_path');
  const name = prop(download, 'document_name', '');
  const fullPath = `https://beta.sanitaske.sk/api/v1/file?query=${path}`;

  return { id, name, path: fullPath };
};

const getZlatapriadkaProductDetailInfo = product => {
  const attribs = prop(product, 'attribs', []);
  const currency = '€';
  const ordernrs = prop(product, 'order_nrs', []);
  const ordernr = ordernrs && ordernrs[0] ? ordernrs[0] : '';

  const description = prop(product, 'description', '');
  const onStock = prop(product, 'main_good_stock_count', 0);
  const availid = prop(product, 'main_good_availability.avail_id', 8);
  const availability = prop(
    product,
    'main_good_availability.translations[0].avail_name',
    'Nedostupné',
  );
  const oldPrice = prop(product, 'main_good_oldprice', 0);
  const price = prop(product, 'main_good_price', 0);

  const url = `/${
    product.url
      ? product.url
      : product.product_publish_url
      ? product.product_publish_url
      : ''
  }`;
  const {
    name,
    picture,
    product_id: id,
    issaleout,
    is_new,
    isnew,
    is_sale,
    issale,
  } = product;
  const brand = prop(product, 'brand.brand_name');
  const sale = prop(product, 'main_good.sale');
  const salePercentage = prop(product, 'main_good.sale_percentage');
  const isSaleB2b = prop(product, 'is_sale_b2b');
  const variants = prop(product, 'variants', []);
  const goods = prop(product, 'goods', []);

  const imageName = picture
    ? picture.substring(picture.lastIndexOf('/') + 1)
    : 'placeholder';

  const imagePath =
    picture && picture.includes('product/')
      ? picture
      : picture
      ? `product/${picture}`
      : '';

  return {
    attribs,
    currency,
    description,
    ordernr,
    onStock,
    availid,
    availability,
    oldPrice: oldPrice ? oldPrice.toFixed(2) : 0,
    price: price ? price.toFixed(2) : 0,
    url,
    id,
    issaleout,
    isnew: isnew || is_new,
    issale: issale || is_sale,
    name,
    picture,
    image: picture
      ? `${process.env.REACT_APP_API_BASE_URL}/image-product-name/${imageName}?query=${imagePath}&width=320&height=320&webp=1&watermark=1`
      : '/images/zlatapriadka/placeholder.svg',
    brand,
    sale,
    salePercentage,
    isSaleB2b,
    variants,
    goods,
  };
};

export {
  getZlataPriadkaProductDefaultInfo,
  getZlatapriadkaProductDetailInfo,
  getElasticCategoryZlataPriadkaProductInfo,
  getZlataPriadkaCartProductInfo,
  getZlataPriadkaTrueCount,
  getCorrectPackageNumber,
  getZlataPriadkaRequestDetailItemInfo,
  getFooterContactRowData,
  isOrderingLessThanMinimum,
  getZlataPriadkaTrueCountFromNormalCount,
  getZlataPriadkaCartSummaryInfo,
  shouldShowPriceIfNotOnStock,
  isCategory,
  findCategoryIdFromArray,
  getDownloadFileInfo,
  getZlataPriadkaSymbolData,
};
